jQuery( document ).ready( function( $ ) {
  var shadowCart = {
    cart: null,
    timeStamp: null,
    fetching: false
  };
  
  var miniCartState = {
    isOpen: false,
    needsUpdate: false
  };
  
  function updateShadowCart(shouldOpenCart){
    if (shadowCart.fetching){
      console.log('Fetching cart, cant start another request');
      return;
    }
    shadowCart.fetching = true;
    $.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json',
      success: function(cart) {
        var previousCart = shadowCart.cart;
        shadowCart.cart = cart;
        shadowCart.timeStamp = new Date().toISOString();
        shadowCart.fetching = false;
        // Trigger watchers after cart is updated
        if (JSON.stringify(previousCart) !== JSON.stringify(cart)) {
          triggerCartWatchers();
          // Open mini cart if requested
          if (shouldOpenCart === true) {
            openMiniCart();
          }
        }
      },
      error: function(xhr, status, error) {
        console.error('Error fetching cart:', error);
        shadowCart.fetching = false;
      }
    });
  }

  function checkIfCartChanged(update = false){
    var changed = false;
    if (shadowCart.fetching){
      console.log('Fetching cart, cant start another request');
      return;
    }
    shadowCart.fetching = true;
    $.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json',
      success: function(cart) {
        if (shadowCart.cart !== cart){
          changed = true;
          console.log('Cart changed');
          if (update){
            shadowCart.cart = cart;
            shadowCart.timeStamp = new Date().toISOString();
          }
          shadowCart.fetching = false;
        }
        else{
          changed = false;
        }
        shadowCart.fetching = false;
        return changed;
      },
      error: function(xhr, status, error) {
        console.error('Error fetching cart:', error);
        shadowCart.fetching = false;
        return changed;
      }
    });
  }

  updateShadowCart();
  
  // Cart watching system
  var cartWatchers = [];
  
  function watchCartChange(callback) {
    if (typeof callback === 'function') {
      cartWatchers.push(callback);
    }
  }
  
  function unwatchCartChange(callback) {
    var index = cartWatchers.indexOf(callback);
    if (index > -1) {
      cartWatchers.splice(index, 1);
    }
  }
  
  function triggerCartWatchers() {
    cartWatchers.forEach(function(callback) {
      try {
        callback(shadowCart.cart, shadowCart.timeStamp);
      } catch (error) {
        console.error('Error in cart watcher:', error);
      }
    });
  }

  function addToCart(id, quantity, openCart){
		$.ajax({
			url: '/cart/add.js',
			method: 'POST',
			dataType: 'json',
			data: {
				id: id,
				quantity: quantity || 1
			},
			success: function(item) {
				console.log('Item added to cart:', item);
				// Update shadow cart - watchers will be triggered automatically
				if (typeof updateShadowCart === 'function') {
					updateShadowCart(openCart === true);
				}
			},
			error: function(xhr, status, error) {
				console.error('Error adding to cart:', error);
				if (xhr.responseJSON && xhr.responseJSON.description) {
					console.error('Error details:', xhr.responseJSON.description);
				}
			}
		});
	}

  // Change cart item quantity
  function changeCartItemQuantity(index, newQuantity){
    var $product = $('.miniCart__product[data-index="' + index + '"]');

    if ($product.length === 0) {
      console.error('Product not found at index:', index);
      return;
    }

    var lineItemKey = null;
    if (shadowCart.cart && shadowCart.cart.items[index]) {
      lineItemKey = shadowCart.cart.items[index].key;
    }

    var variantId = $product.attr('data-product-id');

    if (!lineItemKey && !variantId) {
      console.error('Could not find line item key or variant ID for product at index:', index);
      return;
    }

    // Optimistically update the input
    $product.find('.miniCart__productQtyInput').val(newQuantity);

    var requestData = {};
    if (lineItemKey) {
      requestData = { updates: {} };
      requestData.updates[lineItemKey] = newQuantity;
    } else {
      requestData = { id: variantId, quantity: newQuantity };
    }

    var apiUrl = lineItemKey ? '/cart/update.js' : '/cart/change.js';

    $.ajax({
      url: apiUrl,
      method: 'POST',
      dataType: 'json',
      data: requestData,
      success: function(cart) {
        console.log('Item quantity updated');
        if (typeof updateShadowCart === 'function') {
          updateShadowCart(false);
        }
      },
      error: function(xhr, status, error) {
        console.error('Error updating quantity:', error);
        if (typeof updateShadowCart === 'function') {
          updateShadowCart(false);
        }
        if (xhr.responseJSON && xhr.responseJSON.description) {
          console.error('Error details:', xhr.responseJSON.description);
        }
      }
    });
  }

  function removeFromCart(index){
    // Get the product element
    var $product = $('.miniCart__product[data-index="' + index + '"]');
    
    if ($product.length === 0) {
      console.error('Product not found at index:', index);
      return;
    }

    // Get the line item from shadowCart
    var lineItemKey = null;
    if (shadowCart.cart && shadowCart.cart.items[index]) {
      lineItemKey = shadowCart.cart.items[index].key;
    }

    // Fallback to variant ID if line item key not available
    var variantId = $product.attr('data-product-id');
    
    if (!lineItemKey && !variantId) {
      console.error('Could not find line item key or variant ID for product at index:', index);
      return;
    }

    // Optimistically update UI immediately
    $product.fadeOut(200, function() {
      $product.remove();
      
      // Update cart count and subtotal optimistically
      if (shadowCart.cart && shadowCart.cart.items[index]) {
        var removedItem = shadowCart.cart.items[index];
        var newItemCount = Math.max(0, shadowCart.cart.item_count - removedItem.quantity);
        var newTotal = Math.max(0, shadowCart.cart.total_price - (removedItem.final_line_price || removedItem.line_price));
        
        $('.miniCart__titleRowCount').text('(' + newItemCount + ' items)');
        $('.miniCart__footerSubtotalValue').text(formatPrice(newTotal));
        
        // Show empty message if cart is now empty
        if (newItemCount === 0) {
          $('.miniCart__emptyMessage').show();
        }
      }
    });

    // Remove from Shopify cart using line item key (preferred) or variant ID (fallback)
    var requestData = {};
    if (lineItemKey) {
      // Use update.js with line item key for precise removal
      requestData = {
        updates: {}
      };
      requestData.updates[lineItemKey] = 0;
    } else {
      // Fallback to change.js with variant ID (removes all instances of that variant)
      requestData = {
        id: variantId,
        quantity: 0
      };
    }

    var apiUrl = lineItemKey ? '/cart/update.js' : '/cart/change.js';

    $.ajax({
      url: apiUrl,
      method: 'POST',
      dataType: 'json',
      data: requestData,
      success: function(cart) {
        console.log('Item removed from cart');
        // Update shadow cart - watchers will be triggered automatically
        if (typeof updateShadowCart === 'function') {
          updateShadowCart(false);
        }
      },
      error: function(xhr, status, error) {
        console.error('Error removing from cart:', error);
        // Revert UI update on error by refreshing the cart
        if (typeof updateShadowCart === 'function') {
          updateShadowCart(false);
        }
        if (xhr.responseJSON && xhr.responseJSON.description) {
          console.error('Error details:', xhr.responseJSON.description);
        }
      }
    });
  }

  var miniCartProdTemplate = $('.miniCart__product--template').clone();
  miniCartProdTemplate.removeClass('miniCart__product--template');

  function formatPrice(price){
    return '$' + (parseFloat(price) / 100).toFixed(2);
  }

  function renderMiniCartProduct(product, index){
    var productHtml = miniCartProdTemplate.clone();
    productHtml.attr('data-product-id', product.id);
    productHtml.attr('data-index', index);
    productHtml.find('.miniCart__productImage').attr('src', product.image);
    productHtml.find('.miniCart__productTitle').text(product.product_title);
    productHtml.find('.miniCart__productVariants').text(product.variant_title);
    if (product.discounted_price < product.price){
      productHtml.find('.miniCart__productPriceReduced').show();
      productHtml.find('.miniCart__productPriceReduced').text(formatPrice(product.discounted_price));
      productHtml.find('.miniCart__productPriceOriginal').text(formatPrice(product.price)).addClass('miniCart__productPriceOriginal--reduced');
    }
    else{
      productHtml.find('.miniCart__productPriceReduced').hide();
      productHtml.find('.miniCart__productPriceOriginal').text(formatPrice(product.price));
    }
    productHtml.find('.miniCart__productQtyInput').val(parseInt(product.quantity));
    $('.miniCart__productsContainer').append(productHtml);
  }

  function getPrimaryProduct(cart){
    for (var i = 0; i < cart.items.length; i++){
      var item = cart.items[i];
      if (item.options_with_values.length > 1){
        if (item.options_with_values[0].name === 'Color' && item.options_with_values[1].name === 'Height'){
          var primaryProductInfo = {
            handle: item.handle,
            color: item.options_with_values[0].value,
            height: item.options_with_values[1].value
          }
          return primaryProductInfo;
        }
      }
    }
    return null;
  }

  function renderMiniCartExtra(cart){
    var showPieces = false;

    var primaryProduct = getPrimaryProduct(cart);
    console.log('primaryProduct', primaryProduct);
    if (primaryProduct){
      showPieces = true;
    }

    $('.miniCart__extraContainer--pieces .miniCart__extraProduct').each(function(){
      var triggerArray = $(this).attr('data-trigger-products').split(',');
      if (triggerArray.includes(primaryProduct.handle)){
        $(this).show();
        var variants = $(this).find('.miniCart__extraProductATC').attr('data-variants').split(',');
        var matchLevel = 0;
        for (var j = 0; j < variants.length; j++){
          var variant = variants[j].split('|');
          var variantOptions = variant[0].split(' / ');
          var variantId = variant[1];
          var variantImage = variant[2];
          if (variantOptions[0] === primaryProduct.color && matchLevel < 1){
            $(this).find('.miniCart__extraProductATC').attr('mini-add-to-cart', variantId);
            $(this).find('.miniCart__extraProductImage').attr('src', variantImage);
            matchLevel = 1;
          }
          if (variantOptions[0] === primaryProduct.color && variantOptions[1] === primaryProduct.height && matchLevel < 2){
            $(this).find('.miniCart__extraProductATC').attr('mini-add-to-cart', variantId);
            $(this).find('.miniCart__extraProductImage').attr('src', variantImage);
            matchLevel = 2;
          }
        }
      }
      else{
        $(this).hide();
      }
    });

    if (showPieces){
      $('.miniCart__extraContainer--pieces').show();
      $('.miniCart__extraContainer--upsell').hide();
    }
    else{
      $('.miniCart__extraContainer--pieces').hide();
      $('.miniCart__extraContainer--upsell').show();
    }

    if (cart.items.length > 0){
      $('.miniCart__extra').show();
    }
    else{
      $('.miniCart__extra').hide();
    }
  }

  function checkForMixed(cart){
    var mixed = false;
    var checkColor = "";
    var checkHeight = "";
    for (var i = 0; i < cart.items.length; i++){
      var item = cart.items[i];
      if (item.options_with_values.length > 1){
        if (item.options_with_values[0].name === 'Color'){
          if (checkColor === ""){
            checkColor = item.options_with_values[0].value;
          }
          else{
            if (checkColor !== item.options_with_values[0].value){
              mixed = true;
            }
          }
        }
        if (item.options_with_values[1].name === 'Height'){
          if (checkHeight === ""){
            checkHeight = item.options_with_values[1].value;
          }
          else{
            if (checkHeight !== item.options_with_values[1].value){
              mixed = true;
            }
          }
        }
      }
    }
    if (mixed){
      $('.miniCart__mixedError').show();
    }
    else{
      $('.miniCart__mixedError').hide();
    }
  }

  function updateMiniCart(cart){
    if (cart){
      $('.miniCart__productsContainer').empty();
      for (var i = 0; i < cart.items.length; i++){
        renderMiniCartProduct(cart.items[i], i);
      }
      $('.miniCart__titleRowCount').text('(' + cart.item_count + ' items)');
      $('.miniCart__footerSubtotalValue').text(formatPrice(cart.total_price));
      
      // Show/hide empty message
      if (cart.item_count === 0) {
        $('.miniCart__emptyMessage').show();
      } else {
        $('.miniCart__emptyMessage').hide();
      }
      renderMiniCartExtra(cart);
      checkForMixed(cart);
    }
  }
  
  // Expose watch functions globally
  window.watchCartChange = watchCartChange;
  window.unwatchCartChange = unwatchCartChange;
  window.triggerCartWatchers = triggerCartWatchers;
  window.addToCart = addToCart;
  window.removeFromCart = removeFromCart;
  window.updateShadowCart = updateShadowCart;

  watchCartChange(function(cart, timestamp) {
    console.log('Cart updated!', cart, timestamp);
    // Always update UI when cart changes
    updateMiniCart(cart);
    miniCartState.needsUpdate = false;
  });

  function openMiniCart(){
    miniCartState.isOpen = true;
    $('.miniCartModal').show();
    $('.miniCartModal').addClass('miniCartModal--open');
    $('body').addClass('body--miniCartOpen');
  }
  
  function closeMiniCart(){
    miniCartState.isOpen = false;
    $('.miniCartModal').removeClass('miniCartModal--open');
    $('body').removeClass('body--miniCartOpen');
    setTimeout(function() {
      $('.miniCartModal').hide();
      // Update UI if there were changes while cart was open
      if (miniCartState.needsUpdate && shadowCart.cart) {
        updateMiniCart(shadowCart.cart);
        miniCartState.needsUpdate = false;
      }
    }, 300);
  }

  $('.header__funcButtonWrapper--cart .header__funcButton').on('click', function() {
    openMiniCart();
  });

  $('.miniCart__close, .miniCartModal__bg').on('click', function() {
    closeMiniCart();
  });

  // Remove from cart handler
  $(document).on('click', '.miniCart__productRemove', function(e) {
    e.preventDefault();
    var $product = $(this).closest('.miniCart__product');
    var index = $product.attr('data-index');
    
    if (index !== undefined && index !== null) {
      removeFromCart(parseInt(index));
    } else {
      console.error('Could not find product index');
    }
  });

  // Quantity minus handler
  $(document).on('click', '.miniCart__productQtyMinus', function(e) {
    e.preventDefault();
    var $product = $(this).closest('.miniCart__product');
    var index = $product.attr('data-index');
    var $input = $product.find('.miniCart__productQtyInput');
    var currentQty = parseInt($input.val(), 10) || 1;
    var newQty = Math.max(0, currentQty - 1);

    if (index !== undefined && index !== null) {
      changeCartItemQuantity(parseInt(index), newQty);
    } else {
      console.error('Could not find product index');
    }
  });

  // Quantity plus handler
  $(document).on('click', '.miniCart__productQtyPlus', function(e) {
    e.preventDefault();
    var $product = $(this).closest('.miniCart__product');
    var index = $product.attr('data-index');
    var $input = $product.find('.miniCart__productQtyInput');
    var currentQty = parseInt($input.val(), 10) || 1;
    var newQty = currentQty + 1;

    if (index !== undefined && index !== null) {
      changeCartItemQuantity(parseInt(index), newQty);
    } else {
      console.error('Could not find product index');
    }
  });

  $('.miniCart__extraProductATC').on('click', function(e){
    e.preventDefault();
    var variantId = $(this).attr('mini-add-to-cart');
    addToCart(variantId, 1, false);
  });

});